import { ctx, H } from '../canvas.js';
import { state } from '../state.js';
import { pixelRect } from '../utils.js';

const DEBRIS_GRAVITY = 0.15;

export function drawFx() {
  state.debris.forEach(d => pixelRect(d.x, d.y, d.s, d.s, d.c));

  state.smoke.forEach(s => {
    ctx.globalAlpha = Math.max(0, s.a);
    ctx.fillStyle = s.c;
    ctx.beginPath();
    ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
    ctx.fill();
    ctx.globalAlpha = 1;
  });

  state.fireballs.forEach(f => {
    const g = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, f.r);
    g.addColorStop(0, `rgba(255,244,200,${Math.max(0, f.a)})`);
    g.addColorStop(0.4, `rgba(255,157,60,${Math.max(0, f.a)})`);
    g.addColorStop(1, 'rgba(255,80,40,0)');
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
    ctx.fill();
  });

  // Shockwave rings sit on top of the whole scene and taper as they fade, so
  // the leading edge stays the brightest part of the blast.
  state.shockwaves.forEach(w => {
    ctx.globalAlpha = Math.max(0, w.a);
    ctx.strokeStyle = '#cdf6ff';
    ctx.lineWidth = Math.max(1, 5 * w.a);
    ctx.beginPath();
    ctx.arc(w.x, w.y, w.r, 0, Math.PI * 2);
    ctx.stroke();
    ctx.globalAlpha = 1;
  });
}

/** Advances the particle systems and drops whatever has finished. */
export function updateFx() {
  state.debris.forEach(d => {
    d.vy += DEBRIS_GRAVITY;
    d.x += d.vx;
    d.y += d.vy;
  });
  state.debris = state.debris.filter(d => d.y < H + 20);

  state.smoke.forEach(s => {
    s.y -= s.vy;
    s.x += s.vx;
    s.r += s.dr;
    s.a -= s.fa;
  });
  state.smoke = state.smoke.filter(s => s.a > 0);

  state.fireballs.forEach(f => {
    f.r += f.gr;
    f.a -= f.fade;
  });
  state.fireballs = state.fireballs.filter(f => f.a > 0);

  state.shockwaves.forEach(w => {
    w.r += w.dr;
    w.a -= w.fa;
  });
  state.shockwaves = state.shockwaves.filter(w => w.a > 0);
}
